import { FC } from 'react';
import { variableTypeLabels } from '@app/const';
import { Message, MessageStatus } from '@app/form_components';
import { useDesign } from '@app/hooks';
import { FormControlProps, ModuleInput } from '@app/types';
import { ModuleInputForm } from './ModuleInputForm';

type ModuleInputsFormProps = (
  FormControlProps<ModuleInput[]>
  & {
    moduleId: string;
  }
);

export const ModuleInputsForm: FC<ModuleInputsFormProps> = ({
  moduleId,
  name,
  onBlur,
  onChange,
  onFocus,
  value
}) => {
  value ??= [];
  const serialized = useDesign();
  const appModule = serialized.components.modules.find((m) => m.id === moduleId);

  const handleInputChange = (index: number, newValue: ModuleInput) => {
    const updated = [...value];
    updated[index] = newValue;
    onChange(updated);
  };

  return (
    <>
      {value.map((input, index) => {
        const { argumentName } = input;
        const [, variableName] = argumentName.split('.');
        const variable = appModule?.localVariables?.find((localVar) => {
          return localVar.name === variableName;
        });
        if (!variable) {
          return (
            <Message
              key={input.id}
              message={`Unable to find variable "${variableName}".`}
              status={MessageStatus.error}
            />
          );
        }

        const variableType = variable.props.config.type;
        const variableLabel = (!variableType) ? 'UNKNOWN' : variableTypeLabels[variableType];

        return (
          <ModuleInputForm
            key={input.id}
            label={`${variableName} (${variableLabel})`}
            name={`${name}-input-${input.id}`}
            onBlur={onBlur}
            onChange={(newValue) => handleInputChange(index, newValue)}
            onFocus={onFocus}
            value={input}
            valueType={variableType}
          />
        );
      })}
    </>
  );
};
